import fetch from 'cross-fetch';
import { ApolloClient, ApolloLink, HttpLink, InMemoryCache, defaultDataIdFromObject as dataIdFromObject, } from '@apollo/client/core';
import { setContext } from '@apollo/client/link/context';
import { onError } from '@apollo/client/link/error';
export const getApolloClient = (uri, tokenKey) => {
    const cache = new InMemoryCache({
        dataIdFromObject,
    });
    const httpLink = new HttpLink({
        uri,
        fetch,
    });
    let onUnauthorized = () => ({});
    const requestInterceptor = (_, { headers }) => {
        const token = localStorage.getItem(tokenKey);
        return {
            headers: {
                ...headers,
                Authorization: token ? `Bearer ${token}` : '',
            },
        };
    };
    const responseInterceptor = (operation, forward) => {
        return forward(operation).map((response) => {
            const context = operation.getContext();
            const { response: { headers }, } = context;
            if (headers) {
                const updatedToken = headers.get('refreshed-access-token');
                if (updatedToken) {
                    localStorage.setItem(tokenKey, updatedToken);
                }
            }
            return response;
        });
    };
    const errorInterceptor = ({ graphQLErrors }) => {
        if (graphQLErrors) {
            for (const err of graphQLErrors) {
                if (err.extensions.code === 'UNAUTHENTICATED') {
                    onUnauthorized();
                    break;
                }
            }
            // if (response?.errors) {
            //   const foundUnathorizationCode = response.errors.find((err) => {
            //     const response = err.extensions?.response as ErrorResponse;
            //     if (
            //       Object.prototype.hasOwnProperty.call(response || {}, 'statusCode')
            //     ) {
            //       return response.statusCode === 401;
            //     }
            //     return false;
            //   });
            //   if (foundUnathorizationCode) {
            //     onUnauthorized();
            //   }
            // }
        }
    };
    const authLink = setContext(requestInterceptor);
    const afterwareLink = new ApolloLink(responseInterceptor);
    const errorLink = onError(errorInterceptor);
    const link = ApolloLink.from([afterwareLink, authLink, errorLink, httpLink]);
    const client = new ApolloClient({
        cache,
        link,
    });
    return {
        client,
        setOnUnauthorized: (callback) => {
            onUnauthorized = callback;
        },
    };
};
//# sourceMappingURL=apollo.js.map